<div
  *ngIf="isFirst"
  [style.top]="reportSummary.titleTop"
  [style]="reportSummaryStyle"
  [style.Left]="reportSummary.titleLeft"
  [style.width]="reportSummary.titleWidth"
  [style.height]="reportSummary.titleHeight"
  [style.z-index]="reportSummary.titleZIndex"
  [style.border]="reportSummary.titleBorderStyle"
  [style.border-color]="reportSummary.titleBorderColor"
  [style.border-width]="reportSummary.titleBorderWidth"
  [style.background-color]="reportSummary.titleBackgroundColor"
  [style.justify-content]="reportSummary.titleJustifyContent"
  [style.align-items]="reportSummary.titleAlignItems"
  [style.padding-right]="reportSummary.titlePaddingRight"
  [style.padding-bottom]="reportSummary.titlePaddingBottom"
  [style.padding-left]="reportSummary.titlePaddingLeft"
  [style.padding-top]="reportSummary.titlePaddingTop"
>
  <div
    [style]="textInlineStyle"
    [style.color]="reportSummary.titleFontColor"
    [style.font-size]="reportSummary.titleFontSize"
    [style.font-family]="reportSummary.titleFontFamily"
    [style.font-style]="reportSummary.titleFontStyle"
    [style.font-weight]="reportSummary.titleFontWeight"
    [style.text-align]="reportSummary.titleTextAlign"
    [style.verticalAlign]="reportSummary.titleVerticalAlign"
    [style.line-height]="reportSummary.titleLineHeight"
  >
    <ng-container>{{ reportSummary.titleText }}</ng-container>
  </div>
</div>
<table
  [style]="tableStyle"
  [attr.id]="table.id"
  [style.top]="reportSummary.tableTop"
  [style.left]="reportSummary.tableLeft"
  [style.height]="reportSummary.tableHeight"
  [style.width]="reportSummary.tableWidth"
  [style.z-index]="reportSummary.tableZIndex"
  (click)="onClick($event)"
>
  <tbody>
    <tr
      [style]="trBorderStyle"
      [style.height]="reportSummary.tableHeaderHeight"
      [style.font-size]="reportSummary.tableHeaderFontSize"
      [style.font-family]="reportSummary.tableHeaderFontFamily"
      [style.text-align]="reportSummary.tableHeaderHorizontalAlign"
    >
      <ng-container *ngFor="let column of reportSummary.tableColumns; index as i">
        <th [style.width]="reportSummary.getThWidth(column)" [style.background-color]="reportSummary.tableHeaderBackgroundColor" [style.padding]="0">
          <div
            [style]="summaryThStyle(column)"
            [ngClass]="{ 'summary-th-vertical': column.isHeaderVertical }"
            [style.width]="column.isHeaderVertical ? reportSummary.tableHeaderHeightNum - 1 + sizeUnit : 'auto'"
            [style.padding]="column.padding"
            [style.margin-left]="column.isHeaderVertical ? getMarginLeft(column) : '0' + sizeUnit"
          >
            {{ getTextContent(column) }}
          </div>
        </th>
      </ng-container>
    </tr>
    <tr
      *ngFor="let data of summaryTableData; index as ti"
      [style]="tableDataStyle"
      [style.width]="reportSummary.tableWidth"
      [style.height]="calcTrHeight() + sizeUnit"
    >
      <ng-container *ngFor="let column of reportSummary.tableColumns; index as ci">
        <td
          *ngIf="rowSpans[ti][ci] !== 0"
          [attr.rowspan]="rowSpans[ti][ci]"
          [style.font-size]="column.fontSize + sizeUnit"
          [style.font-family]="column.fontFamily"
          [style.text-align]="column.horizontalAlign"
          [style.vertical-align]="column.verticalAlign"
          [style.padding]="column.padding"
          [style.overflow]="'hidden'"
          [style]="getTableRowStyle(ci + 1)"
        >
          <ng-container *ngIf="column.isColumnVertical">
            <div
              [style.overflow]="'hidden'"
              [style.word-break]="'normal'"
              [style.white-space]="'pre-wrap'"
              [style.line-height]="1"
              [style.white-space]="'normal'"
              [style.transform-origin]="'50% 50%'"
              [style.height]="isBackgroundColorStyle(column) ? '100%' : ''"
              [style]="getTableColumnVerticalStyle(rowHeight, getColumnWidth(column))"
            >
              <app-report-column
                [pageKey]="pageKey"
                [column]="column"
                [columns]="reportSummary.tableColumns"
                [data]="data"
                [trHeight]="rowHeight"
                [sizeUnit]="sizeUnit"
              ></app-report-column>
            </div>
          </ng-container>
          <ng-container *ngIf="!column.isColumnVertical">
            <div
              [style.display]="'block'"
              [style.overflow]="'hidden'"
              [style.word-break]="'normal'"
              [style.white-space]="'normal'"
              [style.max-height]="calcTrHeightForColumn(column, data) + sizeUnit"
              [style.height]="isBackgroundColorStyle(column) ? '100%' : ''"
            >
              <app-report-column
                [pageKey]="pageKey"
                [column]="column"
                [columns]="reportSummary.tableColumns"
                [data]="data"
                [dataMode]="reportSummary.dataMode"
                [trHeight]="rowHeight"
                [sizeUnit]="sizeUnit"
              ></app-report-column>
            </div>
          </ng-container>
        </td>
      </ng-container>
    </tr>
    <tr *ngFor="let row of insertEmptyRows; index as ti" [style.height]="calcTrHeight() + sizeUnit"></tr>
  </tbody>
</table>
